module.exports = __webpack_public_path__ + "static/img/icon-phoneCall.2410805c.png";